<template>
<div>
<BanNer/>
  
<div class="punk">
    <p class="ai a1">404, 页面不见了！</p>
    <p class="ai a2">404, 页面不见了！</p>
</div>
</div>
</template>

<script>
import BanNer from "@/views/Banner/index.vue";	
 export default{
    name:"NotFound",
    components: { BanNer }
 }
</script>

<style scoped>
*{
    margin: 0;
    padding: 0;
}
.punk{
    position: relative;
    width: 100%;
    height: 900px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(115deg, #FF9797 0%, #0F0068 100%), linear-gradient(245deg, #A8FFE5 0%, #0500FF 100%), radial-gradient(100% 225% at 100% 0%, #FF003D 0%, #000000 100%), radial-gradient(90% 160% at 0% 100%, #E42C64 0%, #E42C64 30%, #614AD3 calc(30% + 1px), #614AD3 60%, #2D248A calc(60% + 1px), #2D248A 70%, #121B74 calc(70% + 1px), #121B74 100%), linear-gradient(100deg, #48466F 9%, #48466D 35%, #3D84A8 calc(35% + 1px), #3D84A8 65%, #46CDCF calc(65% + 1px), #46CDCF 70%, #ABEDD8 calc(70% + 1px), #ABEDD8 100%);
    background-blend-mode: overlay, overlay, overlay, overlay, normal;    
}
.ai{
    position: absolute;
    font-size: 80px;
    font-weight: bold;
}
.ai.a1{
    margin-left: 5px;
    color: rgba(248,56,66);
    animation: move-body-a1 0.3s infinite;
}
.ai.a2{
    margin-left: -5px;
    color: rgba(51,204,255);
    mix-blend-mode: lighten;
    animation: move-body-a2 0.2s infinite;
    animation-delay: 0.2s;
}
@keyframes move-body-a1{
    from{
        margin-left: 15px;
    }
    to{
        margin-left: 0px;
    }
}
@keyframes move-body-a2{
    from{
        margin-left: 15px;
    }
    to{
        margin-left: 0px;
    }
}
</style>